module.exports = "<i class=\"far fa-copy warning cursor-pointer\" (click)=\"copyText()\"></i>"